

export const GET_CHARACTER_REQUEST = 'GET_CHARACTER_REQUEST';
export const PUSH_DATA_VIDEO_STEP_ONE = 'PUSH_DATA_VIDEO_STEP_ONE';
export const PUSH_DATA_VIDEO_STEP_TWO = 'PUSH_DATA_VIDEO_STEP_TWO';
export const PUSH_DATA_VIDEO_STEP_THREE = 'PUSH_DATA_VIDEO_STEP_THREE';
export const PUSH_DATA_VIDEO_STEP_FOUR = 'PUSH_DATA_VIDEO_STEP_FOUR';
export const VIDEO_PAYMENT_SAVE_REQUEST = 'VIDEO_PAYMENT_SAVE_REQUEST';
export const VIDEO_PAYMENT_SAVE_SUCCESS = 'VIDEO_PAYMENT_SAVE_SUCCESS';
export const VIDEO_PAYMENT_SAVE_FAILED = 'VIDEO_PAYMENT_SAVE_FAILED';
export const GET_VIDEO_DETAIL_REQUEST = 'GET_VIDEO_DETAIL_REQUEST';
export const GET_VIDEO_DETAIL_SUCCESS = 'GET_VIDEO_DETAIL_SUCCESS';
export const GET_VIDEO_DETAIL_FAILED = 'GET_VIDEO_DETAIL_FAILED';
export const GET_VIDEO_CONTENT_TEMPLATE_REQUEST = 'GET_VIDEO_CONTENT_TEMPLATE_REQUEST';
export const GET_VIDEO_CONTENT_TEMPLATE_SUCCESS = 'GET_VIDEO_CONTENT_TEMPLATE_SUCCESS';
export const GET_VIDEO_CONTENT_TEMPLATE_FAILED = 'GET_VIDEO_CONTENT_TEMPLATE_FAILED';
export const VIDEO_PAYMENT_CLEAR_STATE = 'VIDEO_PAYMENT_CLEAR_STATE';
export const UPDATE_VIDEO_REQUEST = 'UPDATE_VIDEO_REQUEST';
export const UPDATE_VIDEO_SUCCESS = 'UPDATE_VIDEO_SUCCESS';
export const UPDATE_VIDEO_FAILED = 'UPDATE_VIDEO_FAILED';
export const GET_VIDEO_EMOJI_REQUEST = 'GET_VIDEO_EMOJI_REQUEST';
export const GET_VIDEO_EMOJI_SUCCESS = 'GET_VIDEO_EMOJI_SUCCESS';
export const GET_VIDEO_EMOJI_FAILED = 'GET_VIDEO_EMOJI_FAILED';
export const DELETE_VIDEO_REQUEST = 'DELETE_VIDEO_REQUEST';
export const DELETE_VIDEO_SUCCESS = 'DELETE_VIDEO_SUCCESS';
export const DELETE_VIDEO_FAILED = 'DELETE_VIDEO_FAILED';
export const USE_COUPON_FROM_GIFBOX_PAGE = 'USE_COUPON_FROM_GIFBOX_PAGE';
export const UPDATE_EXPLAIN_VIDEO_POPUP_REQUEST = 'UPDATE_EXPLAIN_VIDEO_POPUP_REQUEST';
export const UPDATE_EXPLAIN_VIDEO_POPUP_SUCCESS = 'UPDATE_EXPLAIN_VIDEO_POPUP_SUCCESS';
export const GET_RESTRICTED_KEYWORD_REQUEST = 'GET_RESTRICTED_KEYWORD_REQUEST';
export const GET_RESTRICTED_KEYWORD_SUCCESS = 'GET_RESTRICTED_KEYWORD_SUCCESS';
export const GET_RESTRICTED_KEYWORD_FAILED = 'GET_RESTRICTED_KEYWORD_FAILED';

export const GET_TIME_VIDEO_RENDER_REQUEST = 'GET_TIME_VIDEO_RENDER_REQUEST';
export const GET_TIME_VIDEO_RENDER_SUCCESS = 'GET_TIME_VIDEO_RENDER_SUCCESS';
export const GET_TIME_VIDEO_RENDER_FAILED = 'GET_TIME_VIDEO_RENDER_FAILED';